import React from 'react';
import style from './style.scss'

const Checkbox = (props) => {
    const {field,type="checkbox"} = props;

    return (<div className="">

        <label className={style.formField}
            htmlFor={field.elementId}>
            <input
                autoComplete={field.name}
                className={style.fieldInput}
                id={field.elementId}
                type={type}
                value={field.value}
                placeholder={field.placeholder}
            />
            {field.label}{field.required&&<span className={style.asterisk}> *</span>}
        </label>

    </div>)
}

export default Checkbox;
